import Error404 from "./../../assets/result404.svg";
import {
  Center,
  Heading,
  Text,
  Button,
  HStack,
  Image,
  Box,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const ErrorPage = () => {
  const navigate = useNavigate();
  return (
    <Center className="Layout-container" width="100vw" height="100vh">
      <HStack spacing={1} pl="100">
        <Image boxSize="300px" src={Error404} alt="Error" />
        <Box textAlign="center">
          <Heading as="h1" size="4xl" textAlign="center">
            404
          </Heading>
          <Text mb="2">Sorry, the page you visited does not exist.</Text>
          <Button size="sm" colorScheme="blue" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        </Box>
      </HStack>
    </Center>
  );
};

export default ErrorPage;
